import { registerEngagementWall, registerAdblock, registerPaywall } from 'steady-widget/dist-lib/steady-widget'

const widgetSettings = window.SteadyWidgetSettings
const oauth = window.SteadyWidgetOauth

// TODO: we don't actually need the part to sign int and out
const signIn = () => {
  window.location.assign('/log_in')
}

const signOutLinkSelector = 'a.js-sign_out'
const signOutLink = document.querySelector < HTMLAnchorElement > signOutLinkSelector
const signOut = () => {
  signOutLink?.click()
}

// TODO do we want to add UTM params and all that?
const startPlanSteadyFlow = (planCtaUrl, planPeriod) => {
  const url = new URL(planCtaUrl)
  url.searchParams.append('period', planPeriod)
  window.location.assign(url)
}

const startGiftPlansSteadyFlow = () => {
  window.location.assign(widgetSettings.publicationGiftPlansUrl)
}

const startSteadyFlow = () => {
  window.location.assign(widgetSettings.publicationAboutPageUrl)
}

if (widgetSettings && oauth && !customElements.get('steady-engagement-wall')) {
  registerEngagementWall({ oauth })
}

// TODO: this approach doesn't work for changes of oauth because the custom element stays defined with the initial oauth (also for paywall)
// TODO: should we even bother with expanding the checkout? redirecting to the plans page will do the trick (also for paywall)
if (widgetSettings && oauth && !customElements.get('steady-adblock')) {
  registerAdblock({
    oauth,
    signIn,
    signOut,
    startPlanSteadyFlow,
    startGiftPlansSteadyFlow
  })
}

// TODO: we don't have the notion of dismissible paywalls
if (widgetSettings && oauth && !customElements.get('steady-paywall')) {
  registerPaywall({
    oauth,
    markerId: 'steady-paywall-id',
    paywallContainerClass: 'js-post_body',
    signIn,
    signOut,
    startSteadyFlow,
    startPlanSteadyFlow,
    startGiftPlansSteadyFlow
  })
}
